import { getItem, setItem } from "../../utils/asyncStorage.utils";
import { getStore } from "../../utils/redux/redux.utils";
import * as authSelectors from "./auth.selectors";
var USER_TYPE_KEY = "rentio:auth:user_type";
export var setUserType = function (userId, value) {
    return setItem("".concat(USER_TYPE_KEY, ":").concat(userId), value);
};
export var getUserType = function (userId) {
    return getItem("".concat(USER_TYPE_KEY, ":").concat(userId));
};
export var getUser = function () {
    var _a;
    var state = (_a = getStore()) === null || _a === void 0 ? void 0 : _a.getState();
    if (!state) {
        return;
    }
    return authSelectors.getUser(state);
};
